import { Component, OnInit } from '@angular/core';
import { ActualizarCredencialesEndpointsService } from './services/actualizar-credenciales-endpoints.service'
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { Store } from '@ngrx/store';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';

@Component({
  selector: 'app-actualizar-credenciales',
  templateUrl: './actualizar-credenciales.component.html',
  styleUrls: ['./actualizar-credenciales.component.scss']
})
export class ActualizarCredencialesComponent implements OnInit {

  public sii: string = "";
  public isUpdating = false;

  public userInfo: IUserInfoCognito | null = null
  private _userInfo$ = this.store.select(selectUserInfo);

  public selectedOrganization: string | null = null
  private _selectedOrganization$ = this.store.select(selectSelectedOrganization);

  constructor(
    private _actualizarService: ActualizarCredencialesEndpointsService,
    private _sessionService: SessionService,
    private toastr: ToastrService,
    private router: Router,
    private store: Store) { }

  ngOnInit(): void {

    this.selectedOrganization = this._sessionService.getOrganization();
    this._selectedOrganization$.subscribe((selectedOrganization) => {
      this.selectedOrganization = selectedOrganization;
    })

    this._userInfo$.subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
  }

  onEnviar() {    
    if(this.userInfo && this.selectedOrganization) {
      const userMail = this.userInfo.email;
      const rut = this.selectedOrganization;

      this.isUpdating = true;
      this._actualizarService.validarSii(userMail, rut, this.sii).subscribe(
        (value) => {
          this.actualizar(userMail, rut);
        },
        (error) => {
          console.log(error);
          console.log(error.error);
          console.log(error.status);
          
          if(error.status == 500) {
            this.toastr.error('', error.error.message);
          }
          if (error.status == 401 || error.status == 403) {
            this.toastr.error('', 'No tienes permiso para actualizar estas credenciales');
          } else {
            this.toastr.error('', 'Error al actualizar');
          }
          this.isUpdating = false;
        }
      )
    }
  }

  private actualizar(userMail: string, rut: string) {
    this._actualizarService.actualizarSii(userMail, rut, this.sii).subscribe(
      (value) => {
        this.toastr.success('', 'Las credenciales se han actualizado exitosamente');
        this.router.navigate(['/landing-empresa']);
        this.isUpdating = false;
      },
      (error) => {
        console.log(error);
        console.log(error.error);
        console.log(error.status);
        
        if (error.status == 401 || error.status == 403) {
          this.toastr.error('', 'No tienes permiso para actualizar estas credenciales');
        } else {
          this.toastr.error('', 'Error al actualizar');
        }
        this.isUpdating = false;
      }
    )
  }
}
